"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

require("core-js/modules/es.array.concat.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _table = _interopRequireDefault(require("antd/lib/table"));

var _color = _interopRequireDefault(require("color"));

var _StoreDesign = _interopRequireDefault(require("@meepshop/context/lib/StoreDesign"));

var _filter = _interopRequireDefault(require("@meepshop/utils/lib/filter"));

var _useProductsColumns2 = _interopRequireDefault(require("./hooks/useProductsColumns"));

var _useProductsColumns3 = require("./gqls/useProductsColumns");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// import
require("./styles/products.less");

var styles = {
  "root": "store-cart-previewer__previewer-products__root"
}; // graphql typescript

// definition
var _default = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var viewer = _ref.viewer,
      products = _ref.products;

  var _useContext = (0, _react.useContext)(_StoreDesign["default"]),
      colors = _useContext.colors;

  var _useProductsColumns = (0, _useProductsColumns2["default"])((0, _filter["default"])(_useProductsColumns3.useProductsColumnsInPreviewerUserFragment, viewer)),
      columns = _useProductsColumns.columns,
      columnStyles = _useProductsColumns.styles;

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_table["default"], {
    className: styles.root,
    columns: columns,
    dataSource: (0, _filter["default"])(_useProductsColumns3.useProductsColumnsInPreviewerLineItemFragment, products),
    showHeader: false,
    pagination: false,
    rowKey: "id"
  }), /*#__PURE__*/_react["default"].createElement("style", {
    dangerouslySetInnerHTML: {
      __html: "\n            .".concat(styles.root, " .ant-table {\n              color: ").concat(colors[3], ";\n            }\n\n            .").concat(styles.root, " .ant-table-tbody > tr > td {\n              border-bottom: 1px solid ").concat((0, _color["default"])(colors[5]).alpha(0.5), ";\n            }\n\n            ").concat(columnStyles, "\n          ")
    }
  }));
});

exports["default"] = _default;